export class DateHelper{
    /**
     * formatea una fecha a cadena dado un formato
     * @param format formato de la fecha
     * @param date fecha a formatear
     * @returns cadena con la fecha formateada
     */
    static FormatDate(format: string, date: Date): string{
        if (format && date){
            switch(format){
                case "dd/MM/yyyy":
                    return date.getDate().toString().padStart(2, '0') + "/" + (date.getMonth() + 1).toString().padStart(2, '0') + "/" + date.getFullYear().toString().slice(-2);
                case "dd/MM/yyyy HH:mm":
                    return date.getDate().toString().padStart(2, '0') + "/" + (date.getMonth() + 1).toString().padStart(2, '0') + "/" + date.getFullYear().toString().slice(-2) + " " + date.getHours().toString().padStart(2, '0') + ":" + date.getMinutes().toString().padStart(2, '0');
                default:
                    return "";
            }
        }
        else
        {
            return "";
        }
    }

    /**
     * formatea una fecha 
     * @param date fecha a formatear
     * @returns cadena con la fecha formateada
     */
    static formatDateToString(date: any): string {
        if(date instanceof Date){
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        return ''
    }
      
    /**
     * Convierte una cadena en un objeto Date
     * @param dateStr cadena para convertir en fecha 
     * @returns una fecha de tipo date
     */
    static parseDateString(dateStr: string): Date {
      const [day, month, year] = dateStr.split('/');
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
      
    /**
     * Método para obtener la fecha actual en formato DD/MM/YY
     */
    static getCurrentDate(): string {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = String(now.getFullYear()).slice(2);
      return `${day}/${month}/${year}`;
    }
    
    /**
     * Método para obtener la fecha completa en español
     */
    static getCompleteDate(): string {
      const now = new Date();
      const opciones: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      return now.toLocaleDateString('es-ES', opciones);
    }
    
    /**
     * Método para obtener fecha y hora actual en formato DD/MM/YYYY H:MM:SS
     */
    static getCurrentTime(): string {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
    /**
     * Convierte una fecha a formato ISO pero en hora local (sin zona horaria UTC)
     * Esto evita problemas con la conversión de zona horaria
     */
    static toLocalISOString(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    }
}
